import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { appInsights } from './components/AppInsights/AppInsights';

function toProperties(args: any[]): { [key: string]: any } | undefined {
    if (args.length === 0) {
        return undefined;
    }
    try {
        return { details: JSON.stringify(args.map(a => (a instanceof Error ? { name: a.name, message: a.message } : a))) };
    } catch {
        return { details: String(args) };
    }
}

function send(level: SeverityLevel, message: string, args: any[]) {
    try {
        const error = args.find(a => a instanceof Error) as Error | undefined;
        if (level === SeverityLevel.Error && error) {
            appInsights.trackException({ exception: error, severityLevel: level }, { message });
        } else {
            appInsights.trackTrace({ message, severityLevel: level }, toProperties(args));
        }
    } catch {
        // Telemetry must never break the UI.
    }
}

const logger = {
    info(message: string, ...args: any[]) {
        console.info(message, ...args);
        send(SeverityLevel.Information, message, args);
    },
    warn(message: string, ...args: any[]) {
        console.warn(message, ...args);
        send(SeverityLevel.Warning, message, args);
    },
    error(message: string, ...args: any[]) {
        console.error(message, ...args);
        send(SeverityLevel.Error, message, args);
    }
};

export default logger;
